module.exports = __webpack_public_path__ + "static/media/400092_01.69e49312.png";